module.exports = __webpack_public_path__ + "img/yes-match-c.3073e43c.png";